import branding from '../../../mixins/branding';

require('../scss/payment-card.scss');

export default {
    name: 'payment-card',

    mixins: [branding],

    template: `
        <div class="payment-card">
            <div class="card-number">{{ cardNumber }}</div>
            <div class="card-bottom">
                <div class="card-state" :class="{ selected: selected }">
                    <span v-if="selected">
                        <img svg-inline :src="greenTickIcon" class="w-100">
                    </span>
                </div>
                <div v-if="type !== null" class="card-logo">
                    <img svg-inline :src="cardLogos[type]">
                </div>
            </div>
        </div>
    `,

    data() {
        return {
            cardLogos: {
                'Visa': this.requireVisaCardIcon(),
                'Maestro': this.requireMaestroCardIcon(),
                'MasterCard': this.requireMasterCardIcon(),
                'American Express': this.requireAmericaExpressCardIcon(),
            },
            'greenTickIcon': this.requireGreenTickIcon(),
        };
    },
    props: {
        cardNumber: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: null,
        },
    },
}
